import type { ApiResponse } from './index';

export const NOTIFICATION_TYPE = {
    BROADCAST: 2,
    MAIL: 3,
} as const;

export type NotificationType = typeof NOTIFICATION_TYPE[keyof typeof NOTIFICATION_TYPE];

export interface CreateAdminNotificationPayload {
    title: string;
    message: string;
    type: NotificationType;
    isSendToAll: boolean;
    broadcastReceivers?: string[];
}

export interface AdminNotification {
    _id: string;
    title: string;
    message: string;
    type: number;
    isSendToAll: boolean;
    broadcastReceivers: string[];
    userIds?: string[];
    createdAt: string;
}

export interface AdminNotificationListData {
    list: AdminNotification[];
    totalCount: number;
}

export interface GetAdminNotificationsResponse extends ApiResponse<AdminNotificationListData> { }
export interface GetAdminNotificationResponse extends ApiResponse<AdminNotification> { }
export interface AdminNotificationResponse extends ApiResponse {
    data: any;
}
